import {MatchLiveDataAction, MatchLiveDataState} from './types';
import {MatchDetailCleanup} from '../matchDetail/types';
import {
  MATCH_LIVE_DATA_BY_ID_GET_INVALIDATE,
  MATCH_LIVE_DATA_BY_ID_GET_REQUEST,
  MATCH_LIVE_DATA_BY_ID_GET_RESPONSE,
  MATCHDETAIL_CLEANUP,
} from '../actionTypes';


const initialState: MatchLiveDataState = {
  isFetching: false,
  didInvalidate: false,
};

/**
 * Derives the 'live' state by reducing a new one every time an involved action is dispatches.
 * If the action is not involved (meaning it's not related with this state), then the state
 * is not changed.
 * @param state
 * @param action
 */
const matchLiveDataReducer = (state: MatchLiveDataState = initialState, action: MatchLiveDataAction | MatchDetailCleanup): MatchLiveDataState => {
  switch (action.type) {
    case MATCH_LIVE_DATA_BY_ID_GET_REQUEST:
      return ({
        ...state,
        isFetching: true,
        error: undefined,
      });
    case MATCH_LIVE_DATA_BY_ID_GET_RESPONSE:
      return ({
        ...state,
        isFetching: false,
        didInvalidate: false,
        data: action.payload.matchLiveData,
      });
    case MATCH_LIVE_DATA_BY_ID_GET_INVALIDATE:
      return ({
        ...state,
        isFetching: false,
        didInvalidate: true,
        error: action.error,
      });
    case MATCHDETAIL_CLEANUP:
      return ({...initialState});
    default:
      return state;
  }
};

export default matchLiveDataReducer;
